"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.idsInItems = idsInItems;
exports.itemIdsValidator = itemIdsValidator;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _without = _interopRequireDefault(require("lodash/without"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function idsInItems(items, testIds) {
  var allItemIds = items.map(function (_ref) {
    var id = _ref.id;
    return id;
  });
  return (0, _isEmpty.default)(_without.default.apply(void 0, [testIds].concat(_toConsumableArray(allItemIds))));
}

function itemIdsValidator(props, propName, componentName) {
  if (process.env.NODE_ENV !== 'production') {
    var defaultExpanded = props.defaultExpanded,
        expanded = props.expanded,
        items = props.items,
        current = props[propName];

    if (current && !idsInItems(items, current)) {
      return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`. The value of `").concat(propName, "` must be an array of IDs matching the item IDs. Validation failed."));
    }

    if (defaultExpanded && expanded) {
      return new Error("Both `defaultExpanded` and `expanded` values are supplied to `".concat(componentName, "`. `defaultExpanded` will not be used. Validation failed."));
    }
  }

  return null;
}